// Test IDs for auth + dashboard surface.

export const LOGIN = {
  emailInput: "login-email-input",
  passwordInput: "login-password-input",
  submit: "login-submit-btn",
  submitButton: "login-submit-button",
  error: "login-error",
  forgotPasswordLink: "login-forgot-password-link",
  registerLink: "login-register-link",
};

export const REGISTER = {
  nameInput: "register-name-input",
  emailInput: "register-email-input",
  passwordInput: "register-password-input",
  passwordConfirmInput: "register-password-confirm-input",
  submitButton: "register-submit-button",
  loginLink: "register-login-link",
};

export const LOGOUT = {
  button: "logout-button",
};
